import type { GroupedOptions, Option } from '../types';

export function isGroupedOption(option: Option | GroupedOptions): option is GroupedOptions {
  return 'options' in option;
}
